<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6 order-md-2 d-none d-md-block">
                    <icon-logo
                        height="100%"
                        width="100%"
                        class="img-fluid floating iconBase "
                    />
                </div>
                <div class="col-md-6 order-md-1 mt-5">
                    <div class="pr-md-5">
                        <icon
                            name="ni ni-notification-70"
                            class="mb-5"
                            size="lg"
                            type="success"
                            shadow
                            rounded
                        ></icon>
                        <h3 class="mb-4 qesaco">Qésaco Azterren !</h3>
                        <p class="text-justify">Azterren signifie « racine », « fondation » en Biscayen
                            (dialecte basque) et a inspiré le nom d’un comté
                            gersois, le comté d’Astarac. Une signification forte
                            en accord avec notre démarche et une origine familière,
                            cela nous est apparu comme une évidence.
                            C’est en quelque sorte un retour à nos racines.</p>
                        <p class="text-justify"><b>Azterren</b> sera une épicerie de quartier qui proposera
                            divers produits dont on aura pris le soin
                            de connaître la provenance, qu’ils soient issus de
                            l’élevage, de l’agriculture raisonnée ou biologique.
                            Il en ira de même pour les produits artisanaux.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconLogo from '../components/icons/logo.vue'
export default {
  components: {
    IconLogo,
  },
}
</script>
